import React from "react";
import styled from "styled-components";

const DialogBodyStyle = styled.div`
    overflow: auto;
    max-height: 75vh;
    padding: 22px 30px;
`;

export const DialogBody = ({ children }) =>
    <DialogBodyStyle>
        {children}
    </DialogBodyStyle>;